<template>

<app-page :title="title" back="Users">

    <app-panel title="User" :is-padded="true">

        <app-input type="text" label="First name" placeholder="Enter first name" v-model="model.firstname" />
        <app-input type="text" label="Last name" placeholder="Enter last name" v-model="model.lastname" />
        <app-input type="text" label="E-mail address" placeholder="Enter e-mail address" v-model="model.email" />
        <app-input type="password" label="Password" placeholder="Enter password" v-model="model.password" v-if="isNew" />

    </app-panel>

    <app-panel :title="(isClinic) ? 'Hospital' : 'Hospitals'" :is-padded="true" v-if="model.type && !$isAdmin">

        <app-input type="toggle" label="Restrict Access" v-model="model.hospitals.enabled" :options="enabledOptions" v-if="!isClinic" />
        <app-input type="checklist" :allow-multiple="!isClinic" :label="(isClinic) ? 'Choose Hospital' : 'Permitted Hospitals'" v-model="model.hospitals.allowed" :options="hospitalOptions" empty-message="No hospitals added yet." v-if="requireAllowed" />

    </app-panel>

    <app-panel title="Change Password" :is-collapsed="!model.changepassword" :is-padded="true" v-if="!isNew" v-on:toggle="model.changepassword = $event" :toggled="model.changepassword" has-toggle="Change password">

        <app-input type="password" label="Password" placeholder="Enter password" v-model="model.password" />
        <app-input type="password" label="Confirm Password" placeholder="Enter password again" v-model="model.confirmpassword" />

    </app-panel>

    <app-actions>

        <app-button text="Save" :is-disabled="!canSave" :is-loading="is.saving" v-on:click.native="onSaveClick" />
        <app-button text="Delete" v-if="canDelete" :is-loading="is.deleting" theme="red" v-on:click.native="onDeleteClick" />

    </app-actions>

</app-page>

</template>

<script>

import Vue from 'vue'
import mixForm from '@/mixin/form'
import { required, email, sameAs, minLength, between } from 'vuelidate/lib/validators'

export default {

    mixins: [mixForm],

    data: function() {

        return {
            api: 'users',
            modelExtend: {
                changepassword: false,
                confirmpassword: '',
                password: ''
            },
            redirect: {
                new: 'Users',
                delete: 'Users'
            },
            typeOptions: {
                3: 'Clinic',
                4: 'Data'
            },
            enabledOptions: {
                1: 'Yes',
                0: 'No'
            },
            hospitalOptions: {}
        }

    },

    validations: function() {

        var validations = {
            model: {
                firstname: { 
                    required 
                },
                lastname: { 
                    required 
                },
                email: { 
                    email, 
                    required 
                },
                type: {
                    required,
                    between: between(this.$constants.userType.clinic,  this.$constants.userType.data)
                }
            }
        }

        if (this.requirePassword) {
        
            validations.model.password = { 
                required,
                minLength: minLength(6)
            }
        
        }

        if (this.requirePasswordConfirm) {
        
            validations.model.confirmpassword = { 
                sameAs: sameAs(function() { return this.model.password })
            }
        
        }

        if (this.requireAllowed) {

            validations.model.hospitals = {
                allowed: { 
                    required
                }
            }
        
        }

        return validations

    },

    computed: {

        requireAllowed: function() {
        
            return this.isClinic || ((this.model.hospitals) ? this.model.hospitals.enabled : 0)

        },

        isClinic: function() {
        
            return this.model.type === this.$constants.userType.clinic

        },

        requirePassword: function() {
        
            return this.isNew || this.model.changepassword

        },

        requirePasswordConfirm: function() {
        
            return this.model.changepassword

        },
    
        title: function() {

            return (this.isNew) ? 'Add User' : 'Edit User'
        
        }
    
    },

    methods: {
    
        afterLoad: function(json) {
        
            Vue.set(this, 'hospitalOptions', json.hospitals)
        
        }
    
    }

}

</script>

<style scoped>

</style>
